// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'Flyttade ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accCommandKey: () => 'Kommando',
  accControlKey: () => 'Stäng',
  accPositionAfter: () => 'efter',
  accPositionBefore: () => 'före',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Håll ned tangenterna ' +
    p['keyPressed'] +
    ' och shift och använd sedan piltangenterna för att sortera om.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Ange ett slutförandedatum med det här formatet: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Ange en månad och ett år med det här formatet: ' + p['dateExample'] + '.',
  chart_labelGroup: () => 'Grupp',
  chart_labelSeries: () => 'Serie',
  chart_labelValue: () => 'Värde',
  checkboxSet_requiredMessageDetail: () => 'Obligatorisk',
  checkbox_requiredMessageDetail: () => 'Obligatorisk',
  close: () => 'Stäng',
  collection_noData: () => 'Inga data att visa.',
  collection_selectAllRows: () => 'Välj alla rader',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Välj rad ' + p['ROW_NAME'],
  collection_sortDisabled: () => 'Ej sorterbar',
  collection_sortEnabled: () => 'Sorterbar',
  confirmation: () => 'Bekräftelse',
  datePicker_currentDate: () => 'Aktuellt datum',
  datePicker_goToToday: () => 'Gå till dagens datum',
  datePicker_label: () => 'Datumväljare',
  datePicker_month: () => 'Månad',
  datePicker_months: () => 'Månader',
  datePicker_next: () => 'Nästa',
  datePicker_nextDecade: () => 'Nästa decennium',
  datePicker_nextMonth: () => 'Nästa månad',
  datePicker_prev: () => 'Föregående',
  datePicker_prevDecade: () => 'Föregående decennium',
  datePicker_prevMonth: () => 'Föregående månad',
  datePicker_restricted: () => 'Begränsad',
  datePicker_selected: () => 'Vald',
  datePicker_today: () => 'I dag',
  datePicker_weekNum: (p: { NUM: string }) => 'Vecka ' + p['NUM'],
  datePicker_weekNumColLabel: () => 'Veckonummer',
  datePicker_year: () => 'År',
  datePicker_years: () => 'År',
  error: () => 'Fel',
  expandableList_expandCollapseInstructionText: () =>
    'Använd piltangenterna till att expandera och komprimera',
  expandableList_groupCollapse: () => 'Komprimerad',
  expandableList_groupExpand: () => 'Expanderad',
  filePicker_addFiles: () => 'Lägg till filer',
  filePicker_dropzonePrimaryText: () => 'Dra och släpp',
  filePicker_dropzoneSecondaryText: () => 'Välj en fil eller släpp en fil här',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Välj eller släpp filer här',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Du kan inte ladda upp filer av typen: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Ladda upp en fil åt gången',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Du kan inte ladda upp filer av typen ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'okänd',
  formControl_clear: () => 'Rensa',
  formControl_day: () => 'Dag',
  formControl_helpAvailable: () => 'Hjälp finns',
  formControl_hide: () => 'Dölj',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Du har nått gränsen på ' +
    ((
      { one: new Intl.NumberFormat('sv').format(p['CHARACTER_LIMIT']) + ' tecken' } as Partial<
        Record<Intl.LDMLPluralRule, string>
      >
    )[new Intl.PluralRules('sv').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('sv').format(p['CHARACTER_LIMIT']) + ' tecken') +
    '.',
  formControl_loading: () => 'Laddar',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Du kan ange upp till ' + p['MAX_LENGTH'] + ' tecken.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' tecken kvar.',
  formControl_month: () => 'Månad',
  formControl_readOnly: () => 'Skrivskyddad',
  formControl_requiredMessageDetail: () => 'Ange ett värde.',
  formControl_show: () => 'Visa',
  formControl_year: () => 'År',
  gantt_labelDate: () => 'Datum',
  gantt_labelEnd: () => 'Slut',
  gantt_labelLabel: () => 'Etikett',
  gantt_labelRow: () => 'Rad',
  gantt_labelStart: () => 'Start',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Hittade ingen matchande sektion.',
  indexer_keyboardInstructionText: () => 'Tryck på Enter för att välja värde.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Mellan ' + p['FROM_SECTION'] + ' och ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Dubbeltryck och håll för att växla till gestläget och dra sedan uppåt eller nedåt för att justera värdet.',
  info: () => 'Information',
  inputDateMask_date_cleared: () => 'Datum rensat',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Tom',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'åååå',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Ange ett datum som infaller på eller före ' + p['max'] + '.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Ange ett datum som infaller på eller efter ' + p['min'] + '.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Ange ett tillgängligt datum.',
  inputDatePicker_instruction: () => 'Tryck på tab-tangenten för att få åtkomst till kalendern.',
  inputDatePicker_selectDate: () => 'Välj ett datum',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Ange en månad och ett år som är ' + p['max'] + ' eller tidigare.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Ange en månad och ett år som är ' + p['min'] + ' eller senare.',
  inputNumber_converterParseError: () => 'Ange ett tal.',
  inputNumber_decrease: () => 'Minska',
  inputNumber_increase: () => 'Öka',
  inputPassword_hidden: () => 'Lösenord dolt',
  inputPassword_hide: () => 'Dölj lösenord',
  inputPassword_show: () => 'Visa lösenord',
  inputSensitiveText_hidden: () => 'Dold känslig text',
  list_msgFetchCompleted: () => 'Har laddats',
  list_msgFetchingData: () => 'Laddar',
  list_suggestion: () => 'Förslag',
  messageToast_allMessagesClosed: () => 'Alla toast-meddelanden är stängda.',
  message_close: () => 'Stäng',
  message_confirmation: () => 'Utfördes',
  message_error: () => 'Fel',
  message_info: () => 'Information',
  message_navigationFromMessagesRegion: () =>
    'Växlar till meddelanderegionen. Tryck på F6 för att navigera tillbaka till föregående element med fokus.',
  message_navigationToMessagesRegion: () =>
    'Meddelanderegionen har nya meddelanden. Tryck på F6 för att navigera till den senaste meddelanderegionen.',
  message_warning: () => 'Varning',
  noData_message: () => 'Det finns inga objekt att visa',
  overflowItemLabel: () => 'Fler flikar',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'Pågår',
  radio_helpForRadio: () => 'Hjälp för alternativknapp',
  radio_requiredMessageDetail: () => 'Välj ett värde.',
  selectMultiple_apply: () => 'Använd',
  selectMultiple_back: () => 'Tillbaka',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Använd vänster- och högerpilarna för att markera valda värden.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Tryck på backstegstangenten eller Delete för att ta bort det valda värdet.',
  selectMultiple_selectedValues: () => 'Valda värden',
  selectMultiple_showSelectedValues: () => 'Visa endast valda värden.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' värden valda.',
  select_addToList: () => 'Lägg till i lista',
  select_addToListAvailable: () => 'Lägg till i tillgänglig lista',
  select_moreSearchOptions: () => 'Fler sökalternativ',
  select_moreSearchOptionsAvailable: () => 'Fler tillgängliga sökalternativ',
  select_noMatchesFound: () => 'Inga träffar.',
  select_oneMatchFound: () => 'En matchning har hittats',
  select_requiredMessageDetail: () => 'Välj ett värde.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Hittade ' + p['TOTAL_SIZE'] + ' matchningar',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Hittade ' + p['TOTAL_SIZE'] + ' eller fler matchningar',
  selectorAll_deselectAll: () => 'Avmarkera alla',
  selectorAll_selectAll: () => 'Markera alla',
  selector_selected: () => 'Kryssruta markerad',
  selector_unselected: () => 'Kryssruta inte markerad',
  tabBarNavigationList_removeCueText: () => 'Kan tas bort',
  timeComponent_tooltipZoomIn: () => 'Zooma in',
  timeComponent_tooltipZoomOut: () => 'Zooma ut',
  train_current: () => 'Aktuell',
  train_message_type: () => 'Meddelandetyp',
  train_not_visited: () => 'Inte besökt',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Steg ' + p['currentStep'] + ' av ' + p['numberOfSteps'],
  train_visited: () => 'Besökt',
  userAssistance_learnMore: () => 'Lär dig mer',
  userAssistance_required: () => 'Obligatorisk',
  vis_clearSelection: () => 'Rensa urval',
  vis_drillable: () => 'Borrningsbar',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' av ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Välj textremsa',
  vis_marqueeZoomTooltip: () => 'Markeringszoom',
  vis_noData: () => 'Inga data att visa',
  vis_panTooltip: () => 'Panorering',
  vis_stateLoaded: () => 'Har laddats',
  vis_stateLoading: () => 'Laddar',
  vis_stateSelected: () => 'Vald',
  vis_stateUnselected: () => 'Ej vald',
  warn: () => 'Varning'
};
export default bundle;
